import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getActiveTimeTypes = (
    backend: string,
    token: string
) => {
    return fetch(
        `${getApiUrl(backend)}get_all_active_timeTypes`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default getActiveTimeTypes;
